/** Dopo una scrittura: si ricaricano le viste che ne dipendono (contatori del menu, cruscotto, elenchi, schede). */
import { useQueryClient } from "@tanstack/react-query";

const DIPENDENTI = ["home", "cruscotto", "segnalazioni", "segnalazione", "nc", "claim", "claim-elenco", "fornitore", "proposte", "report", "registro"];

export function useAggiorna() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ predicate: (q) => DIPENDENTI.includes(String(q.queryKey[0])) });
}
